const config = {
  //apiUrl: "http://localhost:5000",
  apiUrl: "https://tvdisplaycontrol.onrender.com",
  displayUrl: "",
};

export default config;
